import { render, staticRenderFns } from "./ConstructionProjectReportView.vue?vue&type=template&id=f5c297f2&scoped=true&"
import script from "./ConstructionProjectReportView.vue?vue&type=script&lang=js&"
export * from "./ConstructionProjectReportView.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionProjectReportView.vue?vue&type=style&index=0&id=f5c297f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c297f2",
  null
  
)

/* custom blocks */
import block0 from "./ConstructionProjectReportView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports